<template>
    <v-container>
        <v-layout>
            <v-flex md12>
                <v-card>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">Buzón de Quejas y Sugerencias</h3>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <p>
                            <v-btn color="teal"
                                  dark
                                  large
                                  outline
                                  @click.stop="dialog = true"
                            >
                                Nueva queja o sugerencia
                            </v-btn>
                        </p>
                        <v-data-table
                                :headers="headers"
                                :items="lista"
                                hide-actions
                        >
                            <template slot="items" slot-scope="props">
                                <td>{{ props.item.fecha }}</td>
                                <td>{{ props.item.titulo }}</td>
                                <td>
                                    <v-btn flat disabled v-if="props.item.pendiente">
                                        <v-icon left >hourglass_empty</v-icon>
                                        Pendiente
                                    </v-btn>
                                    <v-btn color="primary" flat v-if="!props.item.pendiente" @click="mostrarRespuesta(props.item)">
                                        <v-icon left>visibility</v-icon>
                                        Ver Respuesta
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">Nueva queja o sugerencia</span>
                </v-card-title>
                <v-form>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm12>
                                <v-text-field
                                        v-model="quejaSugerencia.titulo"
                                        label="Título"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12>
                                <v-textarea
                                        v-model="quejaSugerencia.mensaje"
                                        label="Mensaje"
                                        counter
                                        maxlength="2048"
                                ></v-textarea>
                            </v-flex>
                            <v-divider></v-divider>
                        </v-layout>
                    </v-container>
                </v-form>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="blue-grey darken-1" @click="dialog = !dialog; quejaSugerencia = {titulo: '', mensaje: ''}">Cancelar</v-btn>
                    <v-btn :loading="dialogSave" :disabled="dialogSave" color="primary" flat @click="guardarQuejaYSugerencia">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="cargandoDatos" max-width="280px" persistent>
            <v-card>
                <v-card-title>
                    <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <span style="max-width: 150px">Cargando lista de quejas y/o sugerencias</span>
                </v-card-title>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogRespuesta" persistent max-width="500px">
            <v-card>
                <v-card-text>
                    <span class="grey--text">Queja o sugerencia</span>
                    <p v-html="itemBuzon.mensaje"></p>
                    <span class="grey--text">Respuesta</span>
                    <p>{{itemBuzon.respuesta.respuesta}}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="dialogRespuesta = !dialogRespuesta">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'BuzonPage',
    data: () => ({
      cargandoDatos: false,
      dialog: false,
      dialogSave: false,
      dialogRespuesta: false,
      headers: [
        {
          text: 'Fecha',
          value: 'fecha',
          width: '150px'
        },
        {
          text: 'Titulo',
          value: 'titulo'
        },
        {
          text: 'Estado',
          value: 'pendiente',
          width: '150px'
        }
      ],
      quejaSugerencia: {
        titulo: '',
        mensaje: ''
      },
      lista: [],
      itemBuzon: {respuesta: ''}
    }),
    methods: {
      getQuejasYSugerencias () {
        this.cargandoDatos = true
        axios.get('alumno/buzon')
          .then(response => {
            this.cargandoDatos = false
            this.lista = response.data
          })
      },
      guardarQuejaYSugerencia () {
        this.dialogSave = true
        axios.post('alumno/buzon', this.quejaSugerencia)
          .then(() => {
            this.dialogSave = false
            this.dialog = false
            this.getQuejasYSugerencias()
          })
      },
      mostrarRespuesta (item) {
        this.dialogRespuesta = true
        this.itemBuzon = item
      }
    },
    mounted () {
      this.getQuejasYSugerencias()
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/BuzonPage.vue